import BillingRoutes from '@/views/finance/billing/routes'
import BankFeedRoutes from '@/views/finance/bank_feed/routes'
import ReceivablesRoutes from '@/views/finance/receivables/routes'
import UnsentInvoicesRoutes from '@/views/finance/unsent-invoices/routes'
import FinanceInvoicesRoutes from './invoices/routes'
import CCPaymentsRoutes from './cc-payment/routes'
import ReceiptRoutes from './receipts/routes'
import ExpiredCardsRoutes from './expired-cards/routes'
import OrphanedInvoiceItemRoutes from './orphaned-invoice-items/routes'

export default {
    path: '/finance',
    component: () => import('@/views/Index.vue'),
    name: 'finance',
    meta: {
        label: 'Finance',
        auth: true,
        location: 'sidebar-top',
        icon: 'fal fa-file-invoice-dollar fa-fw',
        permission: 'manage-customers',
        group: 'main',
    },
    children: [
        BankFeedRoutes,
        BillingRoutes,
        ReceivablesRoutes,
        CCPaymentsRoutes,
        ReceiptRoutes,
        ExpiredCardsRoutes,
        FinanceInvoicesRoutes,
        OrphanedInvoiceItemRoutes,
        UnsentInvoicesRoutes,
    ],
}
